(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('BIAResponsibilityKeyStaffEditModalController', Controller);

    Controller.$inject = ['$scope', '$q', 'biaResponsibilityService', 'notificationService'];

    function Controller($scope, $q, biaResponsibilityService, notificationService) {

        // Update Key Person Role
        $scope.updateKeyPersonRole = function (role) {
            $scope.keyPerson.RoleID = role.LookupAttributeValueID;
            $scope.keyPerson.Role = role;
        };

        // Delete
        $scope.delete = function () {
            biaResponsibilityService
                .deleteBIAKeyPerson(
                    $scope.boxModel.BIAProfileID,
                    $scope.boxModel.BIAResponsibilityID,
                    $scope.keyPerson.BIAKeyPersonID)
                .then(function () {
                    notificationService.notify('Key Person Deleted Successfully');
                    $scope.close();
                });
        };

        // Save
        $scope.save = function () {
            biaResponsibilityService
                .updateKeyPerson(
                    $scope.boxModel.BIAProfileID,
                    $scope.boxModel.BIAResponsibilityID,
                    $scope.keyPerson)
                .then(function () {
                    notificationService.notify('Changes Saved Successfully');
                    $scope.close();
                });
        };

    }
})();